// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lGSt","colBig":"styles_colBig__2YwFR","colSmall":"styles_colSmall__3zXxq"};